import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=81056a6a&"
import script from "./Export.vue?vue&type=script&lang=js&"
export * from "./Export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports